import { TerminalType } from "../../../../../graphql/types"
import { Button, Form } from "antd"
import { formItemLayoutBalanced } from "../../_components/SettingFormItems"
import * as React from "react"
import { getMibSelectedServiceData, getMibServicePickerSelectedId } from "../../../../common/terminalPickers/selectors"
import { useSelector } from "react-redux"

export const EditSourceRow = () => {
    const selectedTerminalId = useSelector(getMibServicePickerSelectedId)
    const selectedTerminalData = useSelector(getMibSelectedServiceData)
    const isAggregator = selectedTerminalData?.type === TerminalType.Aggregator
    return (
        <div>
            <Form.Item
                className="receipt-setting-form-item"
                style={{
                    marginBottom: "0rem",
                }}
                {...formItemLayoutBalanced}
                label="Service Name, Slug, Activate / Deactivate service">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/locations/edit/${isAggregator ? "aggregator" : "terminal"}/${selectedTerminalId}`}>
                    <Button>Edit Service</Button>
                </a>
            </Form.Item>
        </div>
    )
}
